import React, { useState, useEffect } from "react";
import Checkbox from "../common/form/Checkbox";

export default function Invoices({ invoices, selectedIds, canSelect, onSelect }) {
  return (
    <table className="table table-condensed">
      <thead>
        <tr>
          {canSelect && <th />}
          <th>Invoice Number</th>
          <th>Company</th>
          <th>Branch</th>
          <th>Created At</th>
          <th>Title</th>
          <th>Internal Description</th>
          <th>Data Field Restrictions</th>
        </tr>
      </thead>

      <tbody>
        {invoices.map((invoice) => (
          <tr>
            {canSelect && (
              <td>
                <label>
                  <Checkbox
                    checked={selectedIds.includes(invoice.id)}
                    onChange={(e) => onSelect(invoice, e.target.checked)}
                  />
                </label>
              </td>
            )}
            <td>
              <a href={"/invoicing/invoices/" + invoice.id + "/show"}>
                {invoice.invoice_number}
              </a>
            </td>
            <td>{invoice.company_name}</td>
            <td>{invoice.company_branch_name}</td>
            <td>{invoice.created_at}</td>
            <td>{invoice.title}</td>
            <td>{invoice.internal_description}</td>
            <td>{invoice.data_field_restrictions_f}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
